import { customTV } from '@themenu/design-system'

export const fieldInput = customTV({
  base: '',
  variants: {
    readonly: {
      true: [
        '[&>div]:bg-background-overlay [&>div]:dark:bg-background-overlay-dark',
        '[&_input]:text-content-disabled [&_input]:dark:text-content-disabled-dark',
      ],
    },
  },
})
